import { findIndex } from 'lodash';
import crypto from 'crypto-js';
import { canAnswerPartnerEventQuestions } from '../../../../../utils/events';

const _ = { findIndex };

export function getUnregisteredPlayers(selectedDivisionIds, event, claimedPlayer, lookupResults) {
    const unregisteredPlayers = [];

    if (!event.currentMember?.isPlaying && claimedPlayer) {
        unregisteredPlayers.push({
            id: claimedPlayer.playerId.toString(),
            firstName: claimedPlayer.firstName,
            lastName: claimedPlayer.lastName,
            displayName: `${claimedPlayer.firstName} ${claimedPlayer.lastName}`,
            key: `withid-${claimedPlayer.playerId.toString()}`,
            canAnswerEventQuestions: true,
            isCurrentUser: true,
        });
    }

    const selectedDivisions = event.eventDivisions.filter(d => selectedDivisionIds.includes(d.id));

    selectedDivisions.forEach((div) => {
        if (div.player2) {
            const player = {
                canAnswerEventQuestions: canAnswerPartnerEventQuestions(div, event),
                isCurrentUser: false,
            };
            if (div.player2.id) {
                player.id = div.player2.id;
                player.firstName = div.player2.firstName;
                player.lastName = div.player2.lastName;
                player.displayName = div.player2.displayName;
                player.key = `withid-${div.player2.id}`;
                if (div.player2.profileId <= 0) {
                    player.email = div.player2.email;
                }

                const index = _.findIndex(unregisteredPlayers, { id: div.player2.id });
                const partnerReg = lookupResults[div.player2.memberId];
                const registeredInSelectedDivision = partnerReg?.registeredDivisions?.some(
                    regDiv => selectedDivisionIds.some(id => String(id) === String(regDiv.divisionId)),
                );
                if (index === -1 && !registeredInSelectedDivision) {
                    unregisteredPlayers.push(player);
                }
            } else {
                player.displayName = div.player2.name;
                player.email = div.player2.email;
                player.key = `withoutid-${crypto.MD5(div.player2.email).toString()}`;

                const index = _.findIndex(unregisteredPlayers, { email: div.player2.email });
                if (index === -1) {
                    unregisteredPlayers.push(player);
                }
            }
        }
    });

    return unregisteredPlayers;
}
